<template>
  <div>
    <div class="pricing-header pricing">
      <v-container>
        <v-row class="justify-center">
          <v-col>
            <h1><span>15 Day</span> Money Back Guarantee On All Plans</h1>
          </v-col>
        </v-row>
        <v-row />
      </v-container>
    </div>
    <div class="pricing-table">
      <v-container>
        <v-row class="justify-center mt-8 mb-4">
          <v-col>
            <div
              class="col-md-10 col-md-offset-1 col-xl-8"
              style="margin: auto"
            >
              <table>
                <colgroup />
                <colgroup />
                <colgroup />
                <colgroup />
                <colgroup />

                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>
                      <h2>PRO</h2>
                      <p class="price">
                        <span class="currency">$</span> 25
                        <span class="period">/month</span>
                      </p>
                      <p class="billed">
                        Billed Annually
                      </p>
                    </th>
                    <th>
                      <h2>BUSINESS</h2>
                      <p class="price">
                        <span class="currency">$</span> 47.4
                        <span class="period">/month</span>
                      </p>
                      <p class="billed">
                        Billed Annually
                      </p>
                    </th>
                    <th>
                      <h2>COMPANY</h2>
                      <p class="price">
                        <span class="currency">$</span> 177
                        <span class="period">/month</span>
                      </p>
                      <p class="billed">
                        Billed Annually
                      </p>
                    </th>
                    <th>
                      <h2>CORPORATE</h2>
                      <p class="price">
                        <span class="currency">$</span> 7500
                        <span class="period">/year</span>
                      </p>
                    </th>
                  </tr>
                </thead>

                <tfoot>
                  <tr>
                    <th>&nbsp;</th>
                    <td>
                      <a
                        class="table-btn"
                        href="/subscription/business"
                      >select</a>
                    </td>
                    <td>
                      <a
                        class="table-btn"
                        href="/subscription/company"
                      >select</a>
                    </td>
                    <td>
                      <a
                        class="table-btn"
                        href="/subscription/corporate"
                      >select</a>
                    </td>
                  </tr>
                </tfoot>

                <tbody>
                  <tr>
                    <th>Users</th>

                    <td>3</td>
                    <td>5</td>
                    <td>10</td>
                    <td>30</td>
                  </tr>
                  <tr>
                    <th>Warehouses</th>

                    <td>1</td>
                    <td>1</td>
                    <td>5</td>
                    <td>unlimited</td>
                  </tr>
                  <tr>
                    <th>Barcodes</th>

                    <td><v-icon>mdi-check</v-icon></td>
                    <td><v-icon>mdi-check</v-icon></td>
                    <td>Custom barcode labels - Unlimited</td>
                    <td>Custom barcode labels - Unlimited</td>
                  </tr>
                  <tr>
                    <th>Items</th>

                    <td>2000</td>
                    <td>3000</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                  </tr>
                  <tr>
                    <th>CSV/PDF Reporting</th>

                    <td><v-icon>mdi-check</v-icon></td>
                    <td><v-icon>mdi-check</v-icon></td>
                    <td><v-icon>mdi-check</v-icon></td>
                    <td><v-icon>mdi-check</v-icon></td>
                  </tr>

                  <tr>
                    <th>Alerts</th>

                    <td><v-icon>mdi-check</v-icon></td>
                    <td><v-icon>mdi-check</v-icon></td>
                    <td><v-icon>mdi-check</v-icon></td>
                    <td>Alerts - Custom</td>
                  </tr>

                  <tr>
                    <th>Custom Fields</th>

                    <td>10</td>
                    <td>20</td>
                    <td>Unlimited</td>
                    <td>Unlimited</td>
                  </tr>

                  <tr>
                    <th>Integrations</th>

                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td>10</td>
                    <td>Unlimited</td>
                  </tr>

                  <tr>
                    <th>Assistance</th>

                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td>5 HOURS setup assistance</td>
                    <td>20 HOURS setup assistance</td>
                  </tr>

                  <tr>
                    <th>Backup</th>

                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td>3 months</td>
                    <td>6 months</td>
                  </tr>

                  <tr>
                    <th>User access rights</th>

                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td><v-icon>mdi-check</v-icon></td>
                    <td><v-icon>mdi-check</v-icon></td>
                  </tr>

                  <tr>
                    <th>Phone/Email/Chat Support</th>

                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td>Unlimited</td>
                  </tr>

                  <tr>
                    <th>API access for Integrations</th>

                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td><v-icon>mdi-check</v-icon></td>
                  </tr>

                  <tr>
                    <th>Single Sign On</th>

                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td>&mdash;</td>
                    <td><v-icon>mdi-check</v-icon></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>
        <v-row />
      </v-container>
    </div>
    <div class="py-12 site-bg-grey">
      <v-container>
        <v-row class="justify-space-between">
          <v-col cols="2">
            <img
              src="@/assets/images/pricing-logo/logo1.png"
              alt="logo BRITECHECK"
            >
          </v-col>
          <v-col cols="2">
            <img
              src="@/assets/images/pricing-logo/logo2.png"
              alt="logo BRITECHECK"
            >
          </v-col>
          <v-col cols="2">
            <img
              src="@/assets/images/pricing-logo/logo3.png"
              alt="logo BRITECHECK"
            >
          </v-col>
          <v-col cols="2">
            <img
              src="@/assets/images/pricing-logo/logo4.png"
              alt="logo BRITECHECK"
            >
          </v-col>
          <v-col cols="2">
            <img
              src="@/assets/images/pricing-logo/logo5.png"
              alt="logo BRITECHECK"
            >
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-divider />
    <div class="mt-8">
      <v-container>
        <v-row class="justify-center">
          <v-col
            cols="auto"
            class="change-font font-weight-medium footer-nav"
          >
            <a
              href="https://britecheck.zendesk.com"
              target="_blank"
            >Support</a>
          </v-col>
          <v-col
            cols="auto"
            class="change-font font-weight-medium footer-nav"
          >
            <a href="./blog/index.html">Blog</a>
          </v-col>
          <v-col
            cols="auto"
            class="change-font font-weight-medium footer-nav"
          >
            <a href="contactus.html">Contact Us</a>
          </v-col>
          <v-col
            cols="auto"
            class="change-font font-weight-medium footer-nav"
          >
            <router-link to="/pricing">
              Pricing
            </router-link>
          </v-col>
        </v-row>
        <v-divider class="mt-4" />
        <v-row class="justify-center mt-6">
          <v-col
            cols="auto"
            class="change-font font-weight-medium footer-nav"
          >
            <a href="terms-of-use.html">Terms or Service</a>
          </v-col>
          <v-col
            cols="auto"
            class="change-font font-weight-medium footer-nav"
          >
            <a href="privacy-policy.html">Privacy Policy</a>
          </v-col>
        </v-row>
        <v-row
          class="justify-center mt-10 mb-8"
          style="font-size: 14px; color: #a3a3a3"
        >
          <v-col
            cols="12"
            class="pa-0"
          >
            <p class="change-font font-weight-medium text-center">
              © Copyright 2020-{{ new Date().getFullYear() }} BRITECHECK
            </p>
          </v-col>
          <v-col
            cols="12"
            class="pa-0"
          >
            <p class="change-font font-weight-medium text-center">
              All other logos and trademarks are the property of their
              respective owners.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PricingDesktop',
  data() {
    return {
      pricingElevation: 4,
      collapseOnScroll: true,
      bg: '',
      appbarElevation: 0,
      scrolled: false,
      isLoggedIn: false
    }
  },
  mounted() {
    const curUserData = JSON.parse(localStorage.getItem('curUserData'))
    this.isLoggedIn = !!curUserData
    window.onscroll = () => {
      this.changeColor()
    }
  },
  methods: {
    changeColor() {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        this.scrolled = true
      } else {
        this.scrolled = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.change-font {
  font-family: 'Raleway', sans-serif;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 700;
  font-family: 'Raleway', sans-serif;
  color: #3e3d52;
  line-height: 1.4;
  margin: 0 0 15px;
}
.card-title {
  background-color: #5a5d5f;
  color: white !important;
  font-weight: 900;
  font-size: 1.6em;
  letter-spacing: 0.1rem;
}
.card-price {
  font-size: 2.6em;
  font-weight: 600;
  font-family: sans-serif;
  color: black !important;
}
.card-price .period {
  font-size: 0.8rem;
}
.and-price {
  font-size: 18px;
  display: block;
  color: #b5b5b5 !important;
  font-weight: 700;
  font-family: sans-serif;
}
.price-button {
  font-size: 1.25em !important;
  border-radius: 4px;
  margin-bottom: 8px;
  letter-spacing: 0.1rem;
  font-weight: bold;
  opacity: 0.7;
  height: 45px !important;
  transition: all 0.2s;
  width: 225px;
  max-width: 100%;
  border-color: #524e86 !important;
  background-color: #585382 !important;
  color: white !important;
}
.durable-transition {
  transition: all 0.5s;
}
.nav-pricing {
  margin-left: 20px;
  font-weight: 700;
  font-size: 14px;
}
.pricing {
  padding: 50px 0 15px;
}

.pricing-header {
  background: #e8eaff;
}

.pricing h1 {
  padding: 35px 0 0;
  font-weight: 500;
  text-align: center;
  margin-bottom: 15px;
  font-size: 24px;
  color: #3e3d52;
  font-family: sans-serif;
}

.pricing-table .v-icon {
  color: #444;
}

.pricing-table {
  color: #3a3a3a;
}

.pricing h1 span {
  color: #6c61c5;
  font-family: sans-serif;
}
.site-bg-grey {
  background-color: #f5f5f5;
}
// header .v-toolbar__content {
//   width: 70%;
//   margin: auto;
// }
.nav-pricing a {
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  font-family: Hind, sans-serif;
  color: #393939;
  text-transform: uppercase;
  transition-duration: 300ms;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.7, 1, 0.7, 1);
}
.nav-item-hover:after {
  opacity: 1;
  transition-duration: 400ms;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.7, 1, 0.7, 1);
}

.v-main {
  padding: 0 !important;
}
/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
/* Navbar */
/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
header .navbar-nav {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

header .nav-item {
  position: relative;
  display: block;
}

header .nav-item.active .nav-item-hover:after {
  opacity: 1;
  transition-duration: 400ms;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.7, 1, 0.7, 1);
}

header .nav-item:hover .nav-item-hover:after {
  opacity: 1;
  transition-duration: 400ms;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.7, 1, 0.7, 1);
}
header .nav-item-child:hover {
  color: #5e59a5;
}
header .nav-item-child {
  position: relative;
  display: block;
  font-size: 14px;
  font-weight: 600;
  font-family: Hind, sans-serif;
  color: #393939;
  text-transform: uppercase;
  text-decoration: none;
  padding: 10px 15px;
  transition-duration: 300ms;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.7, 1, 0.7, 1);
}

.page .navbar-fixed-top .header-blog .nav-item-child:hover,
.page .header .nav-item-child:focus {
  color: #fff;
}

header .nav-item-child:hover,
header .nav-item-child:focus {
  background: inherit;
}

header .nav-item-hover {
  position: relative;
}

header .nav-item-hover:after {
  position: absolute;
  top: 20px;
  left: 0;
  transition-duration: 400ms;
  transition-property: all;
  width: 9px;
  height: 2px;
  background: #7671bd;
  opacity: 0;
  content: ' ';
  transition-timing-function: cubic-bezier(0.7, 1, 0.7, 1);
}

.navbar-fixed-top .header-blog .nav-item-child:hover,
header .nav-item-child:focus {
  color: #7671bd;
}

header .navbar-nav-right {
  margin-top: 5px;
}

header .nav-item .nav-button {
  color: #fff;
  line-height: 7px;
  padding: 15px 20px;
  height: 38px;
  box-shadow: 3px 3px 8px rgb(82 82 82 / 50%);
  text-align: center;
  background-image: none;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  transition: 0.3s;
  background-color: #7671bd;
  width: 100%;
  max-width: 250px;
  border-radius: 6px;
  border: none;
}

header .nav-item .nav-button::after {
  content: none;
}

header .nav-item .nav-button:hover {
  background-color: #5e59a5;
}
.footer-nav a {
  text-decoration: none;
  color: #767676;
  font-size: 16px;
}
.footer-nav a:hover {
  color: #7671bd;
}
.nav-icon {
  display: none;
}
table {
  width: 100%;
  text-align: left;
  border-spacing: 0;
  border-collapse: collapse;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

table tbody tr:hover td,
table tbody tr:hover th {
  background: #f1f3f6 !important;
}

th,
td {
  font-family: inherit;
  font-size: 14px;
  line-height: 1.45;
  color: #444;
  vertical-align: middle;
  padding: 1em;
}

th {
  font-weight: 600;
}

colgroup:nth-child(1) {
    width: 20%;
    border: 0 none;
}

colgroup:nth-child(2) {
    width: 20%;
    border: 1px solid #dfe5eb;
}

colgroup:nth-child(3) {
    width: 20%;
    border: 1px solid #dfe5eb;
}

colgroup:nth-child(4) {
    width: 20%;
    border: 1px solid #dfe5eb;
}
colgroup:nth-child(5) {
    width: 20%;
    border: 1px solid #dfe5eb;
}

/* Tablehead */

thead th {
  vertical-align: top;
  background: #def4fe;
  background: -moz-linear-gradient(top, #ffffff 0%, #f5f5f5 100%);
  background: -webkit-linear-gradient(top, #ffffff 0%, #f5f5f5 100%);
  background: -o-linear-gradient(top, #ffffff 0%, #f5f5f5 100%);
  background: -ms-linear-gradient(top, #ffffff 0%, #f5f5f5 100%);
  background: linear-gradient(to bottom, #ffffff 0%, #f5f5f5 100%);
  text-align: center;
  position: relative;
  border-bottom: 1px solid #dfe5eb;
  padding: 2.5em 0 1.5em;
  font-weight: 400;
  color: #999;
}

thead th:nth-child(1) {
  background: transparent;
}

thead th h2 {
  font-weight: 600;
  font-size: 24px;
  line-height: 1.2;
  color: #2c2c49;
  font-family: sans-serif;
}

thead th h2 + .price {
  font-weight: 600;
  font-size: 26px;
  line-height: 1.4;
  margin-bottom: 0;
  color: #383838;
}

thead th h2 + .price .period {
  font-weight: 400;
  font-size: 16px;
}

thead th h2 + .price .currency {
  font-weight: 500;
  font-size: 20px;
}

thead th .billed {
  font-size: 15px;
  color: #9fa1af;
  font-family: sans-serif;
  letter-spacing: 1px;
  font-weight: 400;
}

/* Tablebody */
tbody th {
  background: #fff;
  border-left: 1px solid #dfe5eb;
}

tbody td {
  background: #fff;
  text-align: center;
}

tbody tr:nth-child(even) th,
tbody tr:nth-child(even) td {
  background: #f9f9f9;
  border: 1px solid #dfe5eb;
  border-width: 1px 0 1px 1px;
}

tbody tr:last-child td {
  border-bottom: 0 none;
}

/* Tablefooter */
tfoot th {
  padding: 2em 1em;
  border-top: 1px solid #dfe5eb;
}

tfoot td {
  text-align: center;
  padding: 2em 1em;
  border-top: 1px solid #dfe5eb;
}

.table-btn {
  font-weight: bold;
  background: #fff;
  color: #7671bd !important;
  border: solid 1px #7671bd;
  text-decoration: none;
  text-transform: uppercase;
  display: inline-block;
  padding: 10px 40px;
  border-radius: 0.5em;
  max-width: 220px;
  transition: 0.3s;
}

.table-btn:hover {
  background: #7671bd;
  color: #fff !important;
  border: solid 1px #7671bd;
}
</style>
